import { useState } from "react";
import SiteNavbar from "@/components/SiteNavbar";
import { Shield, Zap, Droplets, Eye } from "lucide-react";

/* ─── IMAGE URLS ─── */
const IMG = {
  logo: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/ENZO%202026%20Logo%20RGB%20Trans-01_50a56c58d8b844dbbd7924c8c679b113.png",
  ddSPlus: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDS%2B_6114cacf205e46548d6798aff2d5bf8f.png",
  ddRS:    "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDRS_3764d684d48849bbbe1c437be33fbe35.png",
  ddRPlus: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDR%2B_526dca0ab8c54567ad32473cb1fbb2df.png",
  ddA:     "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDA_29f6f9b809624fc48f7e855ed955c08e.png",
  dd5:     "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DD5_2494fe12b27146799a4b017e53051eaf.png",
  dd7:     "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DD7_9d81c7dde06e4a59b65b51ed26d8317d.png",
  bottles: "https://skyagent-artifacts.skywork.ai/image/317c2af3-f3bf-4d1a-aeff-3678ee16544c/9217f81c-60af-4179-9254-1ea5c0502d35/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/enzo_detailing_series_ultrawide_2.png",
  motvGS6: "https://static-us-img.skywork.ai/prod/nexus/1781619877/cropped_image_0_1781619877112854842.jpg",
  motvGF6: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876918596078.jpg",
  motvR60: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876715520058.jpg",
  motvMT6: "https://static-us-img.skywork.ai/prod/nexus/1781619875/cropped_image_1_1781619875350709927.jpg",
};

/* ─── DWD DATA ─── */
const dwdModels = [
  {
    id: "dds-plus", name: "DD-S+", type: "COILOVER STREET+", typeTh: "Street",
    badge: "COMFORT", badgeColor: "#2563eb",
    comfort: 60, handling: 40,
    desc: "ยกระดับการขับขี่ในเมืองด้วยความนุ่มนวลที่เป็นเอกลักษณ์ มอบความคุ้มค่าสูงสุดสำหรับผู้ที่ต้องการอัปเกรดจากช่วงล่างเดิม",
    highlight: "ปรับค่า Rebound ได้ 32 ระดับ พร้อมเทคโนโลยี Mono Tube และเคลือบสารป้องกันสนิม",
    performance: "ปรับความสูงได้โดยไม่กระทบต่อค่าความแข็งของสปริง มั่นใจได้ว่าทุกเส้นทางจะเต็มไปด้วยความสบาย",
    features: ["32-Clicks Rebound", "Mono Tube", "Anti-Rust Coating", "Height Adjustable"],
    img: IMG.ddSPlus,
  },
  {
    id: "dd-rs", name: "DD-RS", type: "COILOVER PRO", typeTh: "Racing",
    badge: "2-WAY", badgeColor: "#7c3aed",
    comfort: 20, handling: 80,
    desc: "ทางเลือกที่สมดุลที่สุดสำหรับผู้ที่ใช้รถทั้งบนถนนและสนามแข่ง ด้วย Long-stroke design ที่ให้ระยะยุบตัวที่เหมาะสม",
    highlight: "ถังไนโตรเจนแยกภายนอก ช่วยให้ปรับ Compression และ Rebound ได้อย่างอิสระ",
    performance: "มาพร้อม Aluminum Top Mount เพิ่มความคมในการบังคับเลี้ยว เหมาะสำหรับสาย Performance ที่ต้องการความละเอียดในการตั้งค่า",
    features: ["External N₂ Tank", "2-Way Adjustable", "Aluminum Top Mount", "Long Stroke"],
    img: IMG.ddRS,
  },
  {
    id: "dd-r-plus", name: "DD-R+", type: "COILOVER RACING+", typeTh: "Track",
    badge: "TRACK", badgeColor: "#dc2626",
    comfort: 20, handling: 80,
    desc: "สุดยอดวิศวกรรมสำหรับผู้หลงใหลในความเร็ว ออกแบบมาเพื่อรับมือกับความร้อนสะสมในสนามแข่งโดยเฉพาะ",
    highlight: "Inverted Mono Tube ลูกสูบขนาดใหญ่พิเศษ ทนทานต่อการใช้งานหนัก ลดปัญหา Heat Fade ได้อย่างยอดเยี่ยม",
    performance: "ตอบสนองฉับไว แม่นยำในทุกโค้ง ให้คุณเป็นเจ้าของสนามได้อย่างมั่นใจ",
    features: ["Inverted Mono Tube", "Large Piston", "Heat Fade Resist", "32-Clicks"],
    img: IMG.ddRPlus,
  },
  {
    id: "dd-a", name: "DD-A", type: "ADAPTIVE AIR SUSPENSION", typeTh: "Air",
    badge: "AIR", badgeColor: "#0891b2",
    comfort: 50, handling: 50,
    desc: "อิสระแห่งการปรับระดับความสูงด้วยระบบถุงลมคุณภาพสูง มาพร้อมระบบจัดการอัตโนมัติ",
    highlight: "Seamless Aluminum Air Tank และระบบระบายน้ำอัตโนมัติ (Automatic Drainage)",
    performance: "รองรับ 5-level height memory เพื่อความสะดวกสบายสูงสุดในการใช้งานในทุกสภาวะ",
    features: ["Seamless Aluminum Tank", "5-Level Memory", "Auto Drainage", "One-Touch Lower"],
    img: IMG.ddA,
  },
  {
    id: "dd-5", name: "DD-5", type: "OIL – OFFROAD", typeTh: "Offroad",
    badge: "OFFROAD", badgeColor: "#16a34a",
    comfort: 70, handling: 30,
    desc: "พิชิตทุกสภาพเส้นทางด้วยชุดช่วงล่างสำหรับสายลุยและรถกระบะสมรรถนะสูง",
    highlight: "ยกความสูงได้ 2-2.5 นิ้ว พร้อม Damping ที่ออกแบบมาเพื่อการซับแรงกระแทกทั้งทางเรียบและทางวิบาก",
    performance: "Twin Tube Design กระจายแรงกระแทกได้อย่างสม่ำเสมอ มั่นคงในทุกเส้นทาง",
    features: ["Lift 2–2.5 inch", "Twin Tube Design", "Preset Damping", "Heavy Duty"],
    img: IMG.dd5,
  },
  {
    id: "dd-7", name: "DD-7", type: "NITROGEN – OFFROAD", typeTh: "Offroad Pro",
    badge: "PRO", badgeColor: "#b45309",
    comfort: 50, handling: 50,
    desc: "เหนือชั้นด้วยถังไนโตรเจนภายนอก (External Nitrogen Tank) ปรับแต่งได้หลากหลาย มอบเสถียรภาพสูงสุดในทุกภูมิประเทศ",
    highlight: "External Nitrogen Tank ช่วงชักยาว ควบคุมการยุบตัวได้แม่นยำแม้ในภูมิประเทศที่รุนแรง",
    performance: "ปรับ Damping ได้หลากหลาย รองรับทุกสภาพภูมิประเทศ ทั้ง On-road และ Off-road",
    features: ["Lift 2.5 inch", "External N₂ Tank", "Adjustable Damping", "All Terrain"],
    img: IMG.dd7,
  },
];

/* ─── DETAILING DATA ─── */
const detailingProducts = [
  {
    id: "hyper-wax", name: "HYPER WAX", sub: "Liquid Ceramic Coating", volume: "250ml",
    icon: <Zap size={26} color="#E8212A" />, badge: "Best Seller",
    feature: "สูตร Liquid Ceramic ผสม SiO₂ + Multi-Complex Wax ใช้ง่ายแค่ 'ฉีดแล้วเช็ด' ไม่ต้องขัดสี",
    advantage: "สร้างชั้น Ceramic Film ปกป้องสีรถจากฝุ่น UV และมลภาวะ ให้ความเงาระดับ Showroom",
    benefit: "รถสวยเงาได้ใน 3 นาที ล้างรถง่ายขึ้น ฝุ่นและน้ำไม่เกาะสีรถ ประหยัดค่าเคลือบแก้วราคาสูง",
  },
  {
    id: "hyper-gel", name: "HYPER GEL", sub: "Tyre & Rubber Restoration", volume: "250ml",
    icon: <Shield size={26} color="#E8212A" />, badge: "UV Shield",
    feature: "เจลสูตรพิเศษ Hydrophobic ไม่เหนียวเหนอะหนะ สำหรับยางรถยนต์และชิ้นส่วนสีดำ",
    advantage: "ฟื้นฟูความเงาของยางและพลาสติกสีดำได้ทันที สร้างชั้นป้องกัน UV ความชื้น และโอโซน",
    benefit: "ยางและชิ้นส่วนดูใหม่เหมือนเพิ่งซื้อรถ ป้องกันความเสื่อมสภาพในระยะยาว",
  },
  {
    id: "leather", name: "LEATHER EMULSION", sub: "Intensive Conditioner", volume: "250ml",
    icon: <Droplets size={26} color="#E8212A" />, badge: "Premium Care",
    feature: "สูตร Intensive Emulsion ผสม Multi-Complex Wax พิเศษ ฉีดแล้วเช็ด ง่ายสุดๆ",
    advantage: "บำรุงและฟื้นฟูหนังรถ เบาะหนัง อย่างล้ำลึก แทรกซึมเข้าสู่เนื้อหนัง ป้องกันการแตกแห้ง",
    benefit: "หนังนุ่ม เรียบลื่น ดูใหม่ ไม่แตกแห้ง ลดรอยขีดข่วนเล็กๆ กลิ่นหนังใหม่ รักษามูลค่ารถ",
  },
  {
    id: "rain-shield", name: "RAIN SHIELD", sub: "Water Repellent Coating", volume: "100ml",
    icon: <Eye size={26} color="#E8212A" />, badge: "Safety First",
    feature: "สูตร Hydrophobic Coating เข้มข้น ใช้ได้กับกระจกทุกชนิด ทนทานยาวนาน",
    advantage: "สร้างชั้นเคลือบ Hydrophobic บนกระจกให้น้ำเกาะเป็นหยดกลม กลิ้งออกเองอย่างรวดเร็ว",
    benefit: "ขับรถปลอดภัยกว่าในวันฝนตก ลดอุบัติเหตุ ยืดอายุใบปัดน้ำฝน ใช้ครั้งเดียวทนนาน",
  },
];

/* ─── MOTVE DATA ─── */
const motveModels = [
  {
    id: "gs6", name: "GS6", type: "6-Piston Street Performance", img: IMG.motvGS6,
    desc: "คาลิปเปอร์ 6 ลูกสูบสำหรับใช้งานบนถนนและ Track Day สมรรถนะสูง",
    specs: ["ลูกสูบ 2×31.8 / 2×31.8 / 2×41.3mm", "พื้นที่ลูกสูบ 58cm²", "จานเบรก φ380–400mm", "น้ำหนัก 3.9kg"],
  },
  {
    id: "gf6", name: "GF6", type: "6-Piston Offroad Specialist", img: IMG.motvGF6,
    desc: "คาลิปเปอร์ 6 ลูกสูบออกแบบพิเศษสำหรับรถออฟโรด มีทั้งรุ่น Forged Aluminum และ Cast Iron",
    specs: ["ลูกสูบ 2×36 / 2×38 / 2×41.3mm", "พื้นที่ลูกสูบ 69cm²", "จานเบรก φ335–355mm", "น้ำหนัก 3.9–9.2kg"],
  },
  {
    id: "r60", name: "R60", type: "6-Piston Forged Mono-Block", img: IMG.motvR60,
    desc: "คาลิปเปอร์ 6 ลูกสูบ Forged Mono-Block ตัวเดียว แข็งแกร่งสูงสุด สำหรับ Track Day",
    specs: ["ลูกสูบ 2×27 / 2×31.8 / 2×38mm", "พื้นที่ลูกสูบ 50cm²", "จานเบรก φ355–378mm", "น้ำหนัก 3.5kg"],
  },
  {
    id: "mt6", name: "MT6", type: "6-Piston Performance", img: IMG.motvMT6,
    desc: "คาลิปเปอร์ 6 ลูกสูบสมรรถนะสูง น้ำหนักเบา เหมาะสำหรับการใช้งานบนถนนและ Track",
    specs: ["ลูกสูบ 2×27 / 2×31.8 / 2×38.1mm", "พื้นที่ลูกสูบ 50cm²", "จานเบรก φ355–378mm", "น้ำหนัก 3.5kg"],
  },
];

const CALIPER_COLORS = [
  { name: "แดง", hex: "#DC2626" }, { name: "น้ำเงิน", hex: "#2563EB" },
  { name: "เขียว", hex: "#16A34A" }, { name: "เหลือง", hex: "#CA8A04" },
  { name: "ส้ม", hex: "#EA580C" }, { name: "เงิน", hex: "#9CA3AF" },
  { name: "ดำ", hex: "#1F2937" }, { name: "ขาว", hex: "#F9FAFB" },
];

/* ─── TAB CONFIG ─── */
const TABS = [
  { id: "dwd",      label: "DWD Coilover",      labelTh: "โช้คอัพ & ช่วงล่าง" },
  { id: "detailing",label: "ENZO Detailing",     labelTh: "น้ำยาดูแลรถ"       },
  { id: "motve",    label: "MOTVE Brake",        labelTh: "ระบบเบรก"           },
];

/* ══════════════════════════════════════════
   SECTION: DWD TAB
══════════════════════════════════════════ */
function DWDSection() {
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "48px" }}>
        <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, letterSpacing: "0.2em", fontSize: "13px", textTransform: "uppercase", marginBottom: "8px" }}>
          DWD OFFICIAL DISTRIBUTOR · COILOVER THAILAND
        </p>
        <h2 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(28px,4vw,42px)", fontWeight: 800, textTransform: "uppercase", marginBottom: "12px" }}>
          DWD SUSPENSION SYSTEMS
        </h2>
        <p style={{ color: "#aaa", fontSize: "15px", fontFamily: "Sarabun, sans-serif", maxWidth: "560px", margin: "0 auto" }}>
          โช้คอัพ DWD ทุกซีรีส์ ตั้งแต่สายถนนไปจนถึงสนามแข่ง และออฟโรด
          รองรับรถยนต์ไฟฟ้าทุกรุ่น
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: "24px" }}>
        {dwdModels.map((m) => (
          <div key={m.id} style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "4px", overflow: "hidden", transition: "border-color 0.2s, transform 0.2s" }}
            onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(232,33,42,0.5)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(-3px)"; }}
            onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)"; }}>
            {/* Top bar */}
            <div style={{ height: "3px", background: m.badgeColor }} />
            {/* Image */}
            <div style={{ background: "#0a0a0a", padding: "28px 20px", display: "flex", justifyContent: "center", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              <img src={m.img} alt={m.name} style={{ height: "300px", objectFit: "contain", maxWidth: "100%" }} />
            </div>
            {/* Content */}
            <div style={{ padding: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                <div>
                  <span style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", fontWeight: 700, letterSpacing: "0.1em" }}>{m.typeTh}</span>
                  <h3 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "26px", fontWeight: 800, lineHeight: 1, margin: "2px 0 4px" }}>{m.name}</h3>
                  <p style={{ color: "#888", fontFamily: "Rajdhani, sans-serif", fontSize: "12px", letterSpacing: "0.1em" }}>{m.type}</p>
                </div>
                <span style={{ background: m.badgeColor, color: "#fff", padding: "3px 10px", borderRadius: "2px", fontSize: "11px", fontWeight: 700, fontFamily: "Rajdhani, sans-serif", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>{m.badge}</span>
              </div>
              <p style={{ color: "#bbb", fontSize: "13px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.6, marginBottom: "10px" }}>{m.desc}</p>
              {/* Highlight / Performance */}
              {m.highlight && (
                <div style={{ marginBottom: "6px", paddingLeft: "10px", borderLeft: "2px solid #E8212A" }}>
                  <span style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "10px", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", display: "block", marginBottom: "2px" }}>Highlight</span>
                  <p style={{ color: "#ccc", fontSize: "12px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.5, margin: 0 }}>{m.highlight}</p>
                </div>
              )}
              {m.performance && (
                <div style={{ marginBottom: "12px", paddingLeft: "10px", borderLeft: "2px solid #f59e0b" }}>
                  <span style={{ color: "#f59e0b", fontFamily: "Rajdhani, sans-serif", fontSize: "10px", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", display: "block", marginBottom: "2px" }}>Performance</span>
                  <p style={{ color: "#ccc", fontSize: "12px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.5, margin: 0 }}>{m.performance}</p>
                </div>
              )}
              {/* Comfort/Handling bars */}
              <div style={{ marginBottom: "12px" }}>
                {[{ label: "Comfort", val: m.comfort, color: "#2563eb" }, { label: "Handling", val: m.handling, color: "#E8212A" }].map(b => (
                  <div key={b.label} style={{ marginBottom: "6px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "3px" }}>
                      <span style={{ color: "#aaa", fontSize: "11px", fontFamily: "Rajdhani, sans-serif", fontWeight: 600 }}>{b.label}</span>
                      <span style={{ color: b.color, fontSize: "11px", fontFamily: "Rajdhani, sans-serif", fontWeight: 700 }}>{b.val}%</span>
                    </div>
                    <div style={{ height: "4px", background: "#222", borderRadius: "2px" }}>
                      <div style={{ height: "100%", width: `${b.val}%`, background: b.color, borderRadius: "2px", transition: "width 0.6s ease" }} />
                    </div>
                  </div>
                ))}
              </div>
              {/* Feature tags */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {m.features.map(f => (
                  <span key={f} style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#ccc", padding: "3px 8px", borderRadius: "2px", fontSize: "11px", fontFamily: "Rajdhani, sans-serif" }}>{f}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* CTA */}
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <a href="https://lin.ee/usuFQKq" target="_blank" rel="noopener noreferrer"
          style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "14px 32px", background: "#E8212A", color: "#fff", textDecoration: "none", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, fontSize: "15px", letterSpacing: "0.05em", textTransform: "uppercase", borderRadius: "2px" }}>
          สอบถามราคา &amp; สั่งจอง DWD
        </a>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   SECTION: DETAILING TAB
══════════════════════════════════════════ */
function DetailingSection() {
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "48px" }}>
        <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, letterSpacing: "0.2em", fontSize: "13px", textTransform: "uppercase", marginBottom: "8px" }}>
          ENZO CAR DETAILING · PREMIUM PRODUCTS
        </p>
        <h2 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(28px,4vw,42px)", fontWeight: 800, textTransform: "uppercase", marginBottom: "12px" }}>
          ENZO DETAILING COLLECTION
        </h2>
        <p style={{ color: "#aaa", fontSize: "15px", fontFamily: "Sarabun, sans-serif", maxWidth: "560px", margin: "0 auto" }}>
          ผลิตภัณฑ์ดูแลรถยนต์คุณภาพพรีเมียม ปกป้องและเพิ่มความงามให้รถของคุณ
        </p>
      </div>
      {/* Hero image — dark bg, contain to show full bottles */}
      <div style={{ background: "#000", border: "1px solid rgba(255,255,255,0.06)", borderRadius: "4px", marginBottom: "48px", padding: "40px 20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img src={IMG.bottles} alt="ENZO Detailing Products" style={{ width: "100%", maxWidth: "100%", maxHeight: "480px", objectFit: "contain" }} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: "24px" }}>
        {detailingProducts.map((p) => (
          <div key={p.id} style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "4px", overflow: "hidden", transition: "border-color 0.2s, transform 0.2s" }}
            onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(232,33,42,0.5)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(-3px)"; }}
            onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)"; }}>
            <div style={{ height: "3px", background: "#E8212A" }} />
            <div style={{ padding: "22px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  {p.icon}
                  <div>
                    <h3 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "20px", fontWeight: 800, margin: 0 }}>{p.name}</h3>
                    <p style={{ color: "#888", fontFamily: "Rajdhani, sans-serif", fontSize: "11px", letterSpacing: "0.1em", margin: 0 }}>{p.sub}</p>
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <span style={{ background: "rgba(232,33,42,0.15)", border: "1px solid rgba(232,33,42,0.3)", color: "#E8212A", padding: "3px 10px", borderRadius: "2px", fontSize: "11px", fontWeight: 700, fontFamily: "Rajdhani, sans-serif", whiteSpace: "nowrap" }}>{p.badge}</span>
                  <p style={{ color: "#666", fontFamily: "Rajdhani, sans-serif", fontSize: "11px", margin: "4px 0 0", letterSpacing: "0.05em" }}>{p.volume}</p>
                </div>
              </div>
              {/* FAB */}
              {[
                { label: "Feature", color: "#E8212A", text: p.feature },
                { label: "Advantage", color: "#f59e0b", text: p.advantage },
                { label: "Benefit", color: "#4ade80", text: p.benefit },
              ].map(row => (
                <div key={row.label} style={{ marginBottom: "10px", paddingLeft: "10px", borderLeft: `2px solid ${row.color}` }}>
                  <span style={{ color: row.color, fontFamily: "Rajdhani, sans-serif", fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", display: "block", marginBottom: "2px" }}>{row.label}</span>
                  <p style={{ color: "#ccc", fontSize: "13px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.6, margin: 0 }}>{row.text}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <a href="https://lin.ee/usuFQKq" target="_blank" rel="noopener noreferrer"
          style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "14px 32px", background: "#E8212A", color: "#fff", textDecoration: "none", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, fontSize: "15px", letterSpacing: "0.05em", textTransform: "uppercase", borderRadius: "2px" }}>
          สอบถามสินค้า ENZO Detailing
        </a>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   SECTION: MOTVE TAB
══════════════════════════════════════════ */
function MotveSection() {
  const [selectedColor, setSelectedColor] = useState<string | null>(null);

  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "48px" }}>
        <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, letterSpacing: "0.2em", fontSize: "13px", textTransform: "uppercase", marginBottom: "8px" }}>
          MOTVE OFFICIAL DISTRIBUTOR · THAILAND
        </p>
        <h2 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(28px,4vw,42px)", fontWeight: 800, textTransform: "uppercase", marginBottom: "12px" }}>
          MOTVE BRAKE SYSTEMS
        </h2>
        <p style={{ color: "#aaa", fontSize: "15px", fontFamily: "Sarabun, sans-serif", maxWidth: "560px", margin: "0 auto" }}>
          ระบบเบรกสมรรถนะสูง คาลิปเปอร์ 6 ลูกสูบ สำหรับทั้งถนนและสนามแข่ง
          รับประกันโครงสร้างคาลิปเปอร์ 5 ปี
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: "24px", marginBottom: "48px" }}>
        {motveModels.map((m) => (
          <div key={m.id} style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "4px", overflow: "hidden", transition: "border-color 0.2s, transform 0.2s" }}
            onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(232,33,42,0.5)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(-3px)"; }}
            onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)"; }}>
            <div style={{ height: "3px", background: "#E8212A" }} />
            <div style={{ background: "#0a0a0a", padding: "20px", display: "flex", justifyContent: "center", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              <img src={m.img} alt={m.name} style={{ height: "240px", objectFit: "contain", maxWidth: "100%" }} />
            </div>
            <div style={{ padding: "20px" }}>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "12px", fontWeight: 700, letterSpacing: "0.1em" }}>MOTVE</span>
                <h3 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "28px", fontWeight: 800, lineHeight: 1, margin: "2px 0 2px" }}>{m.name}</h3>
                <p style={{ color: "#888", fontFamily: "Rajdhani, sans-serif", fontSize: "12px", letterSpacing: "0.08em", marginBottom: "8px" }}>{m.type}</p>
                <p style={{ color: "#bbb", fontSize: "13px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.6, marginBottom: "12px" }}>{m.desc}</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                {m.specs.map(s => (
                  <div key={s} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ width: "4px", height: "4px", borderRadius: "50%", background: "#E8212A", flexShrink: 0 }} />
                    <span style={{ color: "#ccc", fontSize: "12px", fontFamily: "Sarabun, sans-serif" }}>{s}</span>
                  </div>
                ))}
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                  <span style={{ width: "4px", height: "4px", borderRadius: "50%", background: "#4ade80", flexShrink: 0 }} />
                  <span style={{ color: "#4ade80", fontSize: "12px", fontFamily: "Sarabun, sans-serif", fontWeight: 600 }}>รับประกันโครงสร้าง 5 ปี</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Color selector */}
      <div style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "4px", padding: "32px", marginBottom: "40px" }}>
        <h3 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "22px", fontWeight: 800, textTransform: "uppercase", marginBottom: "8px", textAlign: "center" }}>
          เลือกสีคาลิปเปอร์ได้ตามใจ
        </h3>
        <p style={{ color: "#aaa", fontSize: "14px", fontFamily: "Sarabun, sans-serif", textAlign: "center", marginBottom: "24px" }}>
          มีให้เลือก 8 สี — สั่งทำตามต้องการ พร้อมเลือกลายจานเบรกได้
        </p>
        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "16px" }}>
          {CALIPER_COLORS.map(c => (
            <button key={c.name} onClick={() => setSelectedColor(c.name === selectedColor ? null : c.name)}
              style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", background: "none", border: "none", cursor: "pointer", padding: "8px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: c.hex, border: selectedColor === c.name ? "3px solid #E8212A" : "3px solid rgba(255,255,255,0.1)", transition: "border-color 0.2s, transform 0.2s", transform: selectedColor === c.name ? "scale(1.15)" : "scale(1)", boxShadow: c.hex === "#F9FAFB" ? "inset 0 0 0 1px rgba(0,0,0,0.2)" : "none" }} />
              <span style={{ color: selectedColor === c.name ? "#E8212A" : "#aaa", fontSize: "11px", fontFamily: "Rajdhani, sans-serif", fontWeight: 600 }}>{c.name}</span>
            </button>
          ))}
        </div>
        {selectedColor && (
          <p style={{ textAlign: "center", marginTop: "16px", color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "14px", fontWeight: 700 }}>
            เลือกสี: {selectedColor} — สอบถามรายละเอียดผ่าน LINE ด้านล่าง
          </p>
        )}
      </div>

      <div style={{ textAlign: "center" }}>
        <a href="https://lin.ee/usuFQKq" target="_blank" rel="noopener noreferrer"
          style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "14px 32px", background: "#E8212A", color: "#fff", textDecoration: "none", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, fontSize: "15px", letterSpacing: "0.05em", textTransform: "uppercase", borderRadius: "2px" }}>
          สอบถามราคา &amp; สั่งจอง MOTVE
        </a>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════
   MAIN PAGE
══════════════════════════════════════════ */
export default function ProductsPage() {
  const [activeTab, setActiveTab] = useState<"dwd" | "detailing" | "motve">("dwd");

  return (
    <div style={{ background: "#0D0D0D", minHeight: "100vh" }}>
      <SiteNavbar />

      {/* Page Hero */}
      <div style={{ paddingTop: "100px", paddingBottom: "40px", borderBottom: "1px solid rgba(255,255,255,0.06)", background: "linear-gradient(180deg,#111 0%,#0D0D0D 100%)" }}>
        <div className="container mx-auto px-4" style={{ textAlign: "center" }}>
          <img src={IMG.logo} alt="ENZO Performante Store" style={{ height: "48px", objectFit: "contain", marginBottom: "20px" }} />
          <h1 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(32px,5vw,52px)", fontWeight: 900, textTransform: "uppercase", letterSpacing: "0.05em", margin: "0 0 8px" }}>
            OUR PRODUCTS
          </h1>
          <p style={{ color: "#aaa", fontSize: "16px", fontFamily: "Sarabun, sans-serif" }}>
            โช้คอัพ DWD · น้ำยา ENZO · เบรก MOTVE — ครบจบที่เดียว
          </p>
        </div>
      </div>

      {/* Tab Bar */}
      <div style={{ position: "sticky", top: "64px", zIndex: 40, background: "#111", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="container mx-auto px-4">
          <div style={{ display: "flex", gap: 0, overflowX: "auto" }}>
            {TABS.map(t => {
              const active = activeTab === t.id;
              return (
                <button key={t.id} onClick={() => setActiveTab(t.id as typeof activeTab)}
                  style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "14px 28px", background: "none", border: "none", cursor: "pointer", borderBottom: active ? "2px solid #E8212A" : "2px solid transparent", transition: "all 0.2s", whiteSpace: "nowrap", gap: "2px" }}>
                  <span style={{ color: active ? "#E8212A" : "#aaa", fontFamily: "Rajdhani, sans-serif", fontWeight: 800, fontSize: "15px", letterSpacing: "0.06em", textTransform: "uppercase", transition: "color 0.2s" }}>{t.label}</span>
                  <span style={{ color: active ? "#E8212A" : "#666", fontFamily: "Sarabun, sans-serif", fontSize: "12px", transition: "color 0.2s" }}>{t.labelTh}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="container mx-auto px-4" style={{ paddingTop: "56px", paddingBottom: "80px" }}>
        {activeTab === "dwd"       && <DWDSection />}
        {activeTab === "detailing" && <DetailingSection />}
        {activeTab === "motve"     && <MotveSection />}
      </div>

      {/* Footer CTA */}
      <div style={{ background: "#111", borderTop: "1px solid rgba(255,255,255,0.06)", padding: "32px 16px", textAlign: "center" }}>
        <p style={{ color: "#aaa", fontFamily: "Sarabun, sans-serif", fontSize: "14px", marginBottom: "8px" }}>
          📞 086-997-8800 &nbsp;|&nbsp; 📍 DWD THAILAND สาขาประชาอุทิศ
        </p>
        <p style={{ color: "#666", fontFamily: "Sarabun, sans-serif", fontSize: "13px" }}>
          ติดต่อผ่าน LINE @638lkjit หรือโทรหาเราได้เลย
        </p>
      </div>
    </div>
  );
}
